import { Module, VuexModule, Mutation, Action, getModule } from "vuex-module-decorators"
import store from 'Store/index';
import ApiProvider from "Api/ApiProvider";
import { Client, ProductViewModel }  from "Api/CoreApi";


@Module({ dynamic: true, store, name: 'productVariantStore', namespaced: true })
export class ProductVariantStore extends VuexModule {
    private modalIdDictionary: any = {};

    @Action
    async loadVariantCount(args: { languageId: string, productId: string }) {
        const client = ApiProvider.getApiClient();
        var variantList = await client.getVariantCount(args.languageId, args.productId);
        this.setmodalIdDictionary(variantList);
        return variantList;
    }

    @Mutation
    private setmodalIdDictionary(list: ProductViewModel[]) {
        if (this.modalIdDictionary[list[0].productId] == null || typeof this.modalIdDictionary[list[0].productId] == 'undefined') {
            this.modalIdDictionary[list[0].productId] = list[0].itemNumber;
        }
    }

    @Action
    public getModalId(productId: string): string {
        return this.modalIdDictionary[productId];
    }
}
export default getModule(ProductVariantStore);